import Resource from '@/api/resources/Resource'
import { SAMPLE_STATES } from '@/api/resources/entityState/sample-state'
import { keyBy, merge } from 'lodash'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class GrossingSampleService extends Resource {
    constructor() {
        super()
        this.fullSampleStates = []
    }

    async getSampleStates() {
        const response = await this.axios.get(`/grossing/samples/grossingStates`)
        this.fullSampleStates = Object.values(merge(keyBy(response.data, 'code'), keyBy(SAMPLE_STATES, 'code')))
        return this.fullSampleStates
    }

    async ensureSampleStatesAreLoaded() {
        if (this.fullSampleStates.length === 0) {
            await this.getSampleStates()
        }
    }

    getFullSampleStates() {
        return this.fullSampleStates
    }

    async getSummary(labId, summaryRequest, viewAllEnabled) {
        const summaryUrl = viewAllEnabled ? 'anyoneWorkSummary' : 'myWorkSummary'
        return this.axios.put(`/grossing/laboratories/${labId}/samples/${summaryUrl}`, summaryRequest).then(response => {
            const summary = {}
            response.data.forEach(element => {
                summary[element.filterName] = element.filterCount
            })
            return summary
        })
    }

    async paginator(filterModel, params, laboratoryId, url, viewAllEnabled) {
        const filterOption = viewAllEnabled ? `${url}ByAnyone` : `${url}ByMe`
        const response =
            await this.axios.put(
                `/grossing/laboratories/${laboratoryId}/samples/${filterOption}`,
                filterModel,
                { params })
        return response.data
    }

    async exportTo(laboratoryId, sectionLabel, filterModel, sortModel, columns, selectedIds, url, viewAllEnabled, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        const filterOption = viewAllEnabled ? `${url}ByAnyone` : `${url}ByMe`
        return this.axios.put(
            `/grossing/laboratories/${laboratoryId}/samples/${filterOption}/exportToPdf`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }

    async getGrossingDatesHistory(laboratoryId, caseId, sampleId) {
        const response = await this.axios.get(`common/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/grossingDatesHistory`)
        return response.data
    }
}

export default new GrossingSampleService()

export const VIRTUAL_SHELF_OPTIONS_GROSSING_SAMPLE = [
    { key: 1, code: 'IMMEDIATE', label: 'grossing.sidebar.immediate', bgColor: '#d34444', color: '#FFF' },
    { key: 2, code: 'DELAYED', label: 'grossing.sidebar.delayed', bgColor: '#ffcf4d', color: '#000' },
    { key: 3, code: 'INTERMEDIATEPROCESSES', label: 'grossing.sidebar.intermediate', bgColor: '#e67e22', color: '#FFF' },
    { key: 4, code: 'AUTOPSY', label: 'grossing.sidebar.autopsies', bgColor: '#dadada' }
]

export const GROSSING_SAMPLE_STATES = [
    SAMPLE_STATES.REGISTERED.code,
    SAMPLE_STATES.PROCESSED.code,
    SAMPLE_STATES.ARCHIVED.code,
    SAMPLE_STATES.REPROCESSING_REQUESTED.code,
    SAMPLE_STATES.DISCARDED.code,
    SAMPLE_STATES.OUT_OF_LABORATORY.code
]
